<template>
	<i :class="`file-icon nucleo ${fileIcon}`" />
</template>

<script>
export default {
	name: "FileIcon",
	props: {
		extension: {
			type: String,
			required: true
		}
	},
	computed: {
		fileIcon() {
			let fileExt = this.extension;
			if (fileExt) {
				fileExt = fileExt.toLowerCase();
			}
			if(this.fileIsImage(fileExt)) {
				return "nucleo-image-3";
			}
			if(fileExt === "pdf") {
				return "nucleo-file-pdf";
			}
			if(fileExt === "csv") {
				return "nucleo-file-csv";
			}
			if(fileExt === "txt") {
				return "nucleo-file-text01";
			}
			if(["xls", "xlsx"].includes(fileExt)) {
				return "nucleo-file-xlsx";
			}
			if(["doc", "docx"].includes(fileExt)) {
				return "nucleo-file-doc";
			}
			if(["7z", "zip", "rar"].includes(fileExt)) {
				return "nucleo-compressed-file";
			}
			if(["ppt", "pptx"].includes(fileExt)) {
				return "nucleo-file-pptx";
			}
			return "nucleo-file01";
		}
	}
};
</script>
